<template>
  <div class="flex flex-1 flex-col gap-050 min-w-000">
    <span :class="['chip', `chip-${variant}`, 'paragraph-small-text', 'rounded-s']">
      {{ chip }}
    </span>

    <div class="flex flex-col gap-025">
      <span class="headline-h5-headline" data-testid="promo-code-title">
        {{ coupon.info.title }}
      </span>
      <span class="caption-regular text-secondary-secondary" data-testid="promo-code-info">
        {{ info }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { EditorPromoCodeResultVariant } from '../constants/promoCode'

type Props = {
  chip: string
  coupon: NonNullable<BonusCodeCoupon>
  info: string
  variant: EditorPromoCodeResultVariant
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.chip {
  align-self: flex-start;
  padding-inline: token('size/space/gap/025');
  color: token('color/text/accent/fade/accent-fade');
}

.chip-almostthere {
  background: token('color/background/accent/warning/warning');
}

.chip-active {
  background: token('color/background/accent/success/success/light');
}
</style>
